import type { ReactNode } from 'react';

interface FieldProps {
  label?: string;
  hint?: string;
  required?: boolean;
  error?: string;
  children: ReactNode;
}

export function Field({ label, hint, required, error, children }: FieldProps) {
  return (
    <label style={{ display: 'block' }}>
      {label && (
        <span
          style={{
            display: 'block',
            fontSize: 12.5,
            fontWeight: 500,
            color: 'var(--text-1)',
            marginBottom: 6
          }}
        >
          {label}
          {required && <span style={{ color: 'var(--danger)' }}> *</span>}
        </span>
      )}
      {children}
      {hint && !error && (
        <span
          style={{
            display: 'block',
            fontSize: 11.5,
            color: 'var(--text-3)',
            marginTop: 5
          }}
        >
          {hint}
        </span>
      )}
      {error && (
        <span
          style={{
            display: 'block',
            fontSize: 11.5,
            color: 'var(--danger)',
            marginTop: 5
          }}
        >
          {error}
        </span>
      )}
    </label>
  );
}
